import {all, fork} from 'redux-saga/effects';
import ConfigSettingWatcher from './ConfigSetting/sagaWatcher';
import UserSettingWatcher from './UserSetting/sagaWatcher';

export default function*() {
    yield all([fork(ConfigSettingWatcher)]);
    yield all([fork(UserSettingWatcher)]);
}